import React from 'react';
import { SEO } from '../components/SEO';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, ShieldIcon, ZapIcon, DatabaseIcon, ActivityIcon, CheckCircleIcon, ServerIcon, LockIcon, TrendingUpIcon, RefreshCwIcon, MailIcon, ShoppingCartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const HostingPage: React.FC = () => {
  const hostingFeatures = [{
    icon: <RefreshCwIcon className="h-6 w-6" data-id="element-1292" />,
    title: 'Managed hosting & updates',
    description: "Managed hosting voor financieel adviesbureau met automatische updates van WordPress, thema's, en plugins. Wij zorgen dat alles veilig en compatibel blijft."
  }, {
    icon: <LockIcon className="h-6 w-6" data-id="element-1293" />,
    title: 'Veilige webhosting & SSL certificaten',
    description: 'SSL certificaat zakelijke website regelen, actieve beveiligingsplugins, malware-detectie en bescherming tegen ongewenste toegang. Veilige webhosting is onze prioriteit.'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-1294" />,
    title: 'Snelheid & performance',
    description: 'Snel zakelijk hostingpakket met caching en optimalisatie. Snelheidsplugins zorgen voor razendsnelle laadtijden, ook bij grotere websites.'
  }, {
    icon: <DatabaseIcon className="h-6 w-6" data-id="element-1295" />,
    title: 'Back-ups & monitoring',
    description: 'Hosting met backups: dagelijkse back-ups en 24/7 monitoring zodat problemen snel worden gesignaleerd en opgelost.'
  }];
  const benefits = [{
    icon: <CheckCircleIcon className="h-6 w-6" data-id="element-1296" />,
    title: 'Hosting financieel adviesbureau',
    description: 'Speciaal afgestemd op de behoeften van financiële dienstverleners met extra aandacht voor beveiliging.'
  }, {
    icon: <ServerIcon className="h-6 w-6" data-id="element-1297" />,
    title: 'Webhosting boekhoudkantoor',
    description: 'Betrouwbare hosting voor boekhoudkantoren met garantie op uptime en snelheid.'
  }, {
    icon: <ActivityIcon className="h-6 w-6" data-id="element-1298" />,
    title: 'Hosting op maat MKB',
    description: 'Flexibele hosting oplossingen die meegroeien met jouw bedrijf en specifieke wensen.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-1299" />,
    title: 'Betere afstemming met SEO',
    description: 'Technische SEO-optimalisaties worden direct doorgevoerd zonder externe partijen.'
  }, {
    icon: <MailIcon className="h-6 w-6" data-id="element-1300" />,
    title: 'Zakelijke e-mail en hosting',
    description: 'Combineer je hosting met professionele e-mail voor een complete oplossing.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1301">
      <SEO title="Zakelijke hostingpakket administratiekantoor | Noord Digital" description="Zakelijke hostingpakket administratiekantoor met managed hosting, SSL certificaat en veilige webhosting. Snel zakelijk hostingpakket voor financieel adviesbureaus en boekhoudkantoren." keywords="zakelijke hostingpakket administratiekantoor, managed hosting voor financieel adviesbureau, SSL certificaat zakelijke website regelen, veilige webhosting, snel zakelijk hostingpakket, hosting financieel adviesbureau, webhosting boekhoudkantoor, hosting op maat MKB, hosting met backups, zakelijke e-mail en hosting" canonical="https://noorddigital.nl/zakelijke-hosting-financieel-adviseur" data-id="element-1302" />
      <Header data-id="element-1303" />

      {/* Hero Section with Norden */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20 relative overflow-hidden" data-id="element-1304">
        <div className="absolute inset-0 opacity-20" data-id="element-1305">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-1306"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-1307">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-1308">
            {/* Left side - Main content */}
            <div className="lg:col-span-7" data-id="element-1309">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-1310">
                Zakelijke hosting voor financieel adviseurs en
                administratiekantoren
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-1311">
                Op zoek naar een zakelijke hostingpakket administratiekantoor
                dat betrouwbaar en veilig is? Noord Digital biedt managed
                hosting voor financieel adviesbureau met alles wat je nodig
                hebt: van SSL certificaat zakelijke website regelen tot
                dagelijkse back-ups. Onze veilige webhosting zorgt dat je
                website altijd snel en beschikbaar blijft, zonder dat je er zelf
                naar om hoeft te kijken.
              </motion.p>

              {/* CTAs */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-1312">
                <motion.a href="#hosting-features" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-lg group" data-id="element-1313">
                  Bekijk wat onze hosting omvat
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1314" />
                </motion.a>
                <motion.a href="/websites" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-[#007AFF] transition duration-300 group" data-id="element-1315">
                  Website laten maken
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1316" />
                </motion.a>
              </motion.div>
            </div>

            {/* Right side - Norden as Guardian */}
            <div className="lg:col-span-5" data-id="element-1317">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-1318">
                {/* Norden watching over */}
                <div className="text-center mb-6" data-id="element-1319">
                  <motion.div animate={{
                  y: [0, -8, 0]
                }} transition={{
                  repeat: Infinity,
                  duration: 4,
                  ease: 'easeInOut'
                }} className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-full mb-4 p-3 overflow-hidden relative" data-id="element-1320">
                    <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden mascotte - zakelijke hostingpakket administratiekantoor" className="w-full h-full object-cover" data-id="element-1321" />
                    {/* Shield overlay to represent protection */}
                    <motion.div animate={{
                    scale: [1, 1.1, 1]
                  }} transition={{
                    repeat: Infinity,
                    duration: 2,
                    ease: 'easeInOut'
                  }} className="absolute top-2 right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1322">
                      <ShieldIcon className="h-5 w-5 text-[#007AFF]" data-id="element-1323" />
                    </motion.div>
                  </motion.div>
                  <h3 className="font-bold text-[#111827] text-2xl mb-2" data-id="element-1324">
                    Norden waakt over jouw website
                  </h3>
                  <p className="text-[#6B7280] mb-4" data-id="element-1325">
                    24/7 monitoring, dagelijkse back-ups en actieve beveiliging
                  </p>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-1326">
                    Inclusief SSL-certificaat voor veilige verbindingen,
                    automatische back-ups en zakelijke e-mail. Alles wat je
                    nodig hebt voor een professionele online aanwezigheid.
                  </p>
                </div>

                {/* Quick stats */}
                <div className="grid grid-cols-3 gap-4 pt-6 border-t border-gray-200" data-id="element-1327">
                  <motion.div initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.5
                }} className="text-center" data-id="element-1328">
                    <div className="text-2xl font-bold text-[#007AFF] mb-1" data-id="element-1329">
                      99.9%
                    </div>
                    <div className="text-xs text-[#6B7280]" data-id="element-1330">Uptime</div>
                  </motion.div>
                  <motion.div initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.6
                }} className="text-center" data-id="element-1331">
                    <div className="text-2xl font-bold text-[#007AFF] mb-1" data-id="element-1332">
                      24/7
                    </div>
                    <div className="text-xs text-[#6B7280]" data-id="element-1333">Monitoring</div>
                  </motion.div>
                  <motion.div initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 0.7
                }} className="text-center" data-id="element-1334">
                    <div className="text-2xl font-bold text-[#007AFF] mb-1" data-id="element-1335">
                      Dagelijks
                    </div>
                    <div className="text-xs text-[#6B7280]" data-id="element-1336">Back-ups</div>
                  </motion.div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Core Hosting Features */}
      <div id="hosting-features" className="w-full bg-white py-20 md:py-24" data-id="element-1337">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1338">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1339">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1340">
              Wat zit er inbegrepen bij ons zakelijke hostingpakket
              administratiekantoor?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1341">
              Onze hosting is meer dan alleen een server. We zorgen voor een
              complete oplossing waarbij je website altijd veilig, snel en
              up-to-date blijft.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1342">
            {hostingFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-8 transition-all duration-300 group" data-id="element-1343">
                <div className="flex items-start gap-4" data-id="element-1344">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className="flex-shrink-0 w-12 h-12 bg-[#007AFF] rounded-full flex items-center justify-center text-white" data-id="element-1345">
                    {feature.icon}
                  </motion.div>
                  <div className="flex-1" data-id="element-1346">
                    <h3 className="font-bold text-[#111827] text-xl mb-2" data-id="element-1347">
                      {feature.title}
                    </h3>
                    <p className="text-[#6B7280] leading-relaxed" data-id="element-1348">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Why Hosting at Noord Digital - replaces packages */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1349">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1350">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1351">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1352">
              Waarom hosting bij Noord Digital?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1353">
              Bij veel hostingpartijen ben je een nummer. Bij ons krijg je
              persoonlijke aandacht, proactief onderhoud en een team dat je
              website kent. Hosting, website en SEO onder één dak betekent
              snellere doorvoering en betere resultaten.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1354">
            {[{
            stat: '99.9%',
            label: 'Uptime garantie',
            description: 'Je website is altijd bereikbaar voor je klanten. Mocht er toch iets misgaan, dan zijn wij er direct bij.'
          }, {
            stat: '< 1s',
            label: 'Gemiddelde laadtijd',
            description: 'Snelle websites ranken beter in Google én zorgen voor een betere gebruikerservaring.'
          }, {
            stat: '24/7',
            label: 'Monitoring & support',
            description: 'We houden je website dag en nacht in de gaten. Problemen worden vaak opgelost voordat je ze merkt.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-white rounded-2xl p-8 shadow-lg text-center" data-id="element-1355">
                <div className="text-4xl md:text-5xl font-bold text-[#007AFF] mb-2" data-id="element-1356">
                  {item.stat}
                </div>
                <div className="text-lg font-bold text-[#111827] mb-3" data-id="element-1357">
                  {item.label}
                </div>
                <p className="text-[#6B7280] leading-relaxed text-sm" data-id="element-1358">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1359">
            {[{
            title: 'Alles onder één dak',
            description: 'Website, hosting, SEO en e-mail bij één partij. Dat betekent snellere communicatie, betere afstemming en geen gedoe met verschillende leveranciers.'
          }, {
            title: 'Proactief onderhoud',
            description: 'We wachten niet tot er iets misgaat. Updates, beveiligingspatches en optimalisaties worden automatisch en regelmatig uitgevoerd.'
          }, {
            title: 'Schaalbaar wanneer je groeit',
            description: 'Van een eenvoudige website tot een uitgebreide webshop: onze hosting groeit mee zonder dat je hoeft te migreren.'
          }, {
            title: 'Persoonlijk contact',
            description: 'Geen ticketsystemen of chatbots. Je hebt direct contact met het team dat je website heeft gebouwd en beheert.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 flex items-start gap-4 shadow-sm border border-gray-100" data-id="element-1360">
                <div className="w-8 h-8 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1361">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF]" data-id="element-1362" />
                </div>
                <div data-id="element-1363">
                  <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-1364">
                    {item.title}
                  </h3>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-1365">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center mt-12" data-id="element-1366">
            <p className="text-[#6B7280] mb-4" data-id="element-1367">
              Benieuwd wat hosting bij Noord Digital voor jouw website kan
              betekenen?
            </p>
            <motion.a href="/contact" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-3 px-8 rounded-lg transition duration-300 shadow-md hover:shadow-lg group" data-id="element-1368">
              Vraag een vrijblijvend gesprek aan
              <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1369" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Norden SSL & Updates Callout */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1370">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1371">
          <div className="max-w-4xl mx-auto" data-id="element-1372">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-2xl p-8 md:p-12 text-white shadow-xl" data-id="element-1373">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1374">
                {/* Left - Norden visual */}
                <div className="text-center md:text-left" data-id="element-1375">
                  <div className="inline-block relative" data-id="element-1376">
                    <motion.div initial={{
                    opacity: 0,
                    scale: 0.8
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    stiffness: 100
                  }} className="w-40 h-40 bg-white bg-opacity-20 rounded-full flex items-center justify-center p-4 relative overflow-hidden backdrop-blur-sm" data-id="element-1377">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden regelt SSL certificaat en updates" className="w-full h-full object-cover" data-id="element-1378" />
                    </motion.div>
                    {/* Floating icons */}
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, 5, 0]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1379">
                      <LockIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1380" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, -360]
                  }} transition={{
                    y: {
                      duration: 4,
                      repeat: Infinity
                    },
                    rotate: {
                      duration: 10,
                      repeat: Infinity,
                      ease: 'linear'
                    }
                  }} className="absolute -bottom-2 -left-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1381">
                      <RefreshCwIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1382" />
                    </motion.div>
                  </div>
                </div>

                {/* Right - Text */}
                <div data-id="element-1383">
                  <motion.h2 initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} className="font-bold text-white text-3xl mb-4" data-id="element-1384">
                    Norden regelt je SSL-certificaat en updates
                  </motion.h2>
                  <motion.p initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.1
                }} className="text-white text-opacity-90 text-lg leading-relaxed mb-6" data-id="element-1385">
                    Geen gedoe met technische zaken. Norden zorgt automatisch
                    voor je SSL-certificaat, installeert updates en houdt alles
                    veilig. Jij kunt je focussen op je klanten, wij zorgen voor
                    de techniek.
                  </motion.p>
                  <div className="space-y-3" data-id="element-1386">
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.2
                  }} className="flex items-center gap-3" data-id="element-1387">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1388" />
                      <span className="text-white text-opacity-90" data-id="element-1389">
                        Automatische SSL-certificaat installatie en verlenging
                      </span>
                    </motion.div>
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.3
                  }} className="flex items-center gap-3" data-id="element-1390">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1391" />
                      <span className="text-white text-opacity-90" data-id="element-1392">
                        Wekelijkse updates van WordPress en plugins
                      </span>
                    </motion.div>
                    <motion.div initial={{
                    opacity: 0,
                    x: 20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} viewport={{
                    once: true
                  }} transition={{
                    delay: 0.4
                  }} className="flex items-center gap-3" data-id="element-1393">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1394" />
                      <span className="text-white text-opacity-90" data-id="element-1395">
                        Proactieve beveiligingscontroles
                      </span>
                    </motion.div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Hosting for Webshops & Custom */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1396">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1397">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1398">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1399">
              Hosting voor webshops en maatwerk
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed mb-8" data-id="element-1400">
              Naast standaard webhosting boekhoudkantoor bieden we ook
              gespecialiseerde hosting met backups voor webshops en maatwerk
              websites. Of je nu een WooCommerce webshop runt of een complexe
              maatwerk applicatie hebt, ons snel zakelijk hostingpakket groeit
              mee met jouw behoeften. We zorgen voor extra capaciteit,
              geavanceerde caching en optimale performance voor e-commerce.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center justify-center gap-3 mb-8" data-id="element-1401">
              <ShoppingCartIcon className="h-8 w-8 text-[#007AFF]" data-id="element-1402" />
              <span className="text-[#6B7280] font-medium" data-id="element-1403">
                Speciaal geschikt voor WooCommerce en maatwerk oplossingen
              </span>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1404">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-6 transition-all duration-300 group" data-id="element-1405">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-1406">
                  {benefit.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-1407">
                  {benefit.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-1408">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>

          {/* Internal links */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto mt-12" data-id="element-1409">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-1410">
              Complete oplossing voor jouw online aanwezigheid
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-1411">
              Combineer je hosting met onze andere diensten voor een
              professionele online aanwezigheid:
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-1412">
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-sm group" data-id="element-1413">
                Website laten maken
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1414" />
              </motion.a>
              <motion.a href="/email" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-sm group" data-id="element-1415">
                Zakelijke e-mail hosting
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1416" />
              </motion.a>
              <motion.a href="/seo" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-sm group" data-id="element-1417">
                SEO optimalisatie
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1418" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Transparent & Scalable */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#005FCC] py-20 md:py-24" data-id="element-1419">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1420">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1421">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-white text-3xl md:text-4xl mb-6" data-id="element-1422">
              Hosting die meegroeit met je website
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-white text-opacity-90 text-lg leading-relaxed mb-8" data-id="element-1423">
              Naarmate je website groter wordt of meer functionaliteit krijgt,
              vraagt dit om meer capaciteit en onderhoud. Onze hosting groeit
              mee, zonder dat je opnieuw hoeft te migreren. Van een eenvoudige
              website tot een uitgebreide online omgeving, wij zorgen dat alles
              blijft draaien.
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-white text-opacity-90 text-lg leading-relaxed mb-8" data-id="element-1424">
              Benieuwd naar de technische mogelijkheden?{' '}
              <a href="https://wordpress.org" target="_blank" rel="noopener noreferrer" className="text-white font-semibold hover:underline" data-id="element-1425">
                Lees meer over WordPress
              </a>{' '}
              en ontdek waarom dit platform perfect is voor zakelijke websites.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-wrap gap-4 justify-center" data-id="element-1426">
              <motion.a href="/contact" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-semibold rounded-lg hover:bg-gray-100 transition duration-300 shadow-lg group" data-id="element-1427">
                Neem contact op
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1428" />
              </motion.a>
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-[#007AFF] transition duration-300 group" data-id="element-1429">
                Website laten maken
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1430" />
              </motion.a>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer data-id="element-1431" />
    </div>;
};